'use strict';

const HomeyAPI = require('./HomeyAPI');

/**
 * This class is returned by {@link AthomCloudAPI.Homey#authenticate} for a Homey with firmware `<=1.5.13`.
 *
 * @class
 * @hideconstructor
 * @extends HomeyAPI
 */
class HomeyAPIV1 extends HomeyAPI {

  constructor({ properties, api, debug }) {
    super({ properties, api, debug });

    // TODO: Bearer token
    const { token } = this.__properties;
    this.token = token;
  }

  get platform() {
    return 'local';
  }

  get platformVersion() {
    return 1;
  }

  updates = {
    async getUpdates() {
      throw new Error('Not Implemented');
    },
    async installUpdate() {
      throw new Error('Not Implemented');
    },
    async getState() {
      throw new Error('Not Implemented');
    },
  }

  async login() {
    if (!this.token) {
      throw new Error('Missing Token');
    }
  }

}

module.exports = HomeyAPIV1;
